<template>
  <a-form-model ref="form" :model="form" :rules="rules">
    <a-form-model-item label="阿里云邮件密匙ID" prop="apiKey" >
      <a-input v-model="form.apiKey" :placeholder="$t('请输入')+阿里云邮件AccessKeyId" />
    </a-form-model-item>
    <a-form-model-item label="阿里云密钥SECRET" prop="apiSecret" >
      <a-input v-model="form.apiSecret" :placeholder="$t('请输入')+阿里云邮件AccessKeySecret" type="password" />
    </a-form-model-item>
    <a-form-model-item  prop="apiRegion" label="阿里云区域ID" >

      <a-input v-model="form.apiRegion" :placeholder="$t('请输入')+阿里云邮件RegionId"/>
    </a-form-model-item>

    <a-form-model-item :wrapper-col="{ span: 18, offset: 10 }">
      <a-button type="primary" :loading="submitLoading" @click="submitForm">
        保存
      </a-button>
    </a-form-model-item>
  </a-form-model>
</template>
<script>
import {getEmailChannel, updateEmailChanne } from '@/api/email/channel'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      // 表单参数
      form: {
        id: null,
        apiKey: null,
        apiSecret: null,
        apiRegion: null,
      },
      rules: {
        apiKey: [
          { required: true, message: '阿里云邮件AccessKeyId不能为空', trigger: 'blur' }
        ],
        apiSecret: [
          { required: true, message: '阿里云邮件AccessKeySecret不能为空', trigger: 'blur' }
        ],
        apiRegion: [
          { required: true, message: '阿里云邮件RegionId不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    getEmailChannel("ALIYUN").then(respons =>{
      this.form = respons.data
    })
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {

    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateEmailChanne(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
